"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexTypes = exports.indexRelations = exports.indexEntities = exports.relationRefSame = exports.relationRefFromId = exports.relationRefToId = exports.relationToId = exports.relationToRef = exports.relationLinkToAttributeRef = exports.relationLinkToEntityRef = exports.typeToId = exports.typeToRef = exports.typeToNamespace = exports.typeRefSame = exports.typeRefFromId = exports.typeRefToId = exports.attributeTypeParse = exports.constraintRefSame = exports.constraintRefFromId = exports.constraintRefToId = exports.attributesRefSame = exports.attributesRefFromId = exports.attributesRefToId = exports.attributeRefSame = exports.attributeRefToEntity = exports.attributeRefFromId = exports.attributeRefToId = exports.attributePathSame = exports.attributePathFromId = exports.attributePathToId = exports.entityRefFromAttribute = exports.entityToId = exports.entityToRef = exports.entityToNamespace = exports.entityRefSame = exports.entityRefFromId = exports.entityRefToId = exports.namespaceSame = exports.namespaceFromId = exports.namespaceToId = exports.namespace = void 0;
exports.removeQuotes = removeQuotes;
exports.getAttribute = getAttribute;
exports.getPeerAttributes = getPeerAttributes;
exports.flattenAttributes = flattenAttributes;
exports.attributeValueToString = attributeValueToString;
exports.parseJsonDatabase = parseJsonDatabase;
exports.generateJsonDatabase = generateJsonDatabase;
exports.mergeDatabase = mergeDatabase;
exports.mergeDatabaseExtra = mergeDatabaseExtra;
exports.mergeEntity = mergeEntity;
exports.mergeEntityExtra = mergeEntityExtra;
exports.mergeAttribute = mergeAttribute;
exports.mergeAttributeExtra = mergeAttributeExtra;
exports.mergePrimaryKey = mergePrimaryKey;
exports.mergeIndex = mergeIndex;
exports.mergeCheck = mergeCheck;
exports.mergeIndexExtra = mergeIndexExtra;
exports.mergeRelation = mergeRelation;
exports.mergeRelationExtra = mergeRelationExtra;
exports.mergeType = mergeType;
exports.mergeTypeExtra = mergeTypeExtra;
exports.mergeStats = mergeStats;
const utils_1 = require("@azimutt/utils");
const zod_1 = require("./zod");
const database_1 = require("./database");
const parserResult_1 = require("./parserResult");
const legacyDatabase_1 = require("./legacy/legacyDatabase");
const namespace = (n) => (0, utils_1.removeUndefined)({ database: n.database, catalog: n.catalog, schema: n.schema });
exports.namespace = namespace;
const namespaceToId = (n) => [
    n.database || '',
    n.catalog || '',
    n.schema || ''
].map(addQuotes).join('.').replace(/^\.+/, '');
exports.namespaceToId = namespaceToId;
const namespaceFromId = (id) => {
    const [schema, catalog, ...database] = id.split('.').reverse().map(removeQuotes);
    return (0, utils_1.filterValues)({ database: database.reverse().join('.'), catalog, schema }, v => !!v);
};
exports.namespaceFromId = namespaceFromId;
const namespaceSame = (a, b) => (a.schema === b.schema || a.schema === '*' || b.schema === '*') &&
    (a.catalog === b.catalog || a.catalog === '*' || b.catalog === '*') &&
    (a.database === b.database || a.database === '*' || b.database === '*');
exports.namespaceSame = namespaceSame;
const entityRefToId = (ref) => {
    const ns = (0, exports.namespaceToId)(ref);
    return ns ? `${ns}.${ref.entity}` : addQuotes(ref.entity);
};
exports.entityRefToId = entityRefToId;
const entityRefFromId = (id) => {
    const [entity, schema, catalog, ...database] = id.split('.').reverse().map(removeQuotes);
    const namespace = (0, utils_1.filterValues)({ database: database.reverse().join('.'), catalog, schema }, v => !!v);
    return { ...namespace, entity };
};
exports.entityRefFromId = entityRefFromId;
const entityRefSame = (a, b) => (a.entity === b.entity || a.entity === '*' || b.entity === '*') && (0, exports.namespaceSame)(a, b);
exports.entityRefSame = entityRefSame;
const entityToNamespace = (e) => (0, exports.namespace)(e);
exports.entityToNamespace = entityToNamespace;
const entityToRef = (e) => (0, utils_1.removeUndefined)({ ...(0, exports.namespace)(e), entity: e.name });
exports.entityToRef = entityToRef;
const entityToId = (e) => (0, exports.entityRefToId)((0, exports.entityToRef)(e));
exports.entityToId = entityToId;
const entityRefFromAttribute = (a) => {
    const { attribute, ...ref } = a;
    return ref;
};
exports.entityRefFromAttribute = entityRefFromAttribute;
const attributePathToId = (path) => path.join('.');
exports.attributePathToId = attributePathToId;
const attributePathFromId = (path) => path.split('.');
exports.attributePathFromId = attributePathFromId;
const attributePathSame = (p1, p2) => (0, utils_1.arraySame)(p1, p2, (i1, i2) => i1 === i2 || i1 === '*' || i2 === '*');
exports.attributePathSame = attributePathSame;
const attributeRefToId = (ref) => `${(0, exports.entityRefToId)(ref)}(${(0, exports.attributePathToId)(ref.attribute)})`;
exports.attributeRefToId = attributeRefToId;
const attributeRefFromId = (id) => {
    const [, entityId, attributeId] = id.match(/^(.*)\((.*)\)$/) || [];
    const entity = (0, exports.entityRefFromId)(entityId || id);
    const attribute = (0, exports.attributePathFromId)(attributeId || '');
    return { ...entity, attribute };
};
exports.attributeRefFromId = attributeRefFromId;
const attributeRefToEntity = ({ attribute, ...ref }) => ref;
exports.attributeRefToEntity = attributeRefToEntity;
const attributeRefSame = (a, b) => (0, exports.entityRefSame)(a, b) && (0, exports.attributePathSame)(a.attribute, b.attribute);
exports.attributeRefSame = attributeRefSame;
const attributesRefToId = (ref) => `${(0, exports.entityRefToId)(ref)}(${ref.attributes.map(exports.attributePathToId).join(', ')})`;
exports.attributesRefToId = attributesRefToId;
const attributesRefFromId = (id) => {
    const [, entityId, attributeId] = id.match(/^([^(]*)\(([^)]*)\)$/) || [];
    const entity = (0, exports.entityRefFromId)(entityId || id);
    const attributes = (attributeId || '').split(',').map(a => (0, exports.attributePathFromId)(a.trim()));
    return { ...entity, attributes };
};
exports.attributesRefFromId = attributesRefFromId;
const attributesRefSame = (a, b) => (0, exports.entityRefSame)(a, b) && (0, utils_1.arraySame)(a.attributes, b.attributes, exports.attributePathSame);
exports.attributesRefSame = attributesRefSame;
const constraintRefToId = (ref) => `${(0, exports.entityRefToId)(ref)}(${ref.constraint})`;
exports.constraintRefToId = constraintRefToId;
const constraintRefFromId = (id) => {
    const [, entityId, constraintName] = id.match(/^(.*)\((.*)\)$/) || [];
    const entity = (0, exports.entityRefFromId)(entityId || id);
    return { ...entity, constraint: constraintName };
};
exports.constraintRefFromId = constraintRefFromId;
const constraintRefSame = (a, b) => (0, exports.entityRefSame)(a, b) && (a.constraint === b.constraint || a.constraint === '*' || b.constraint === '*');
exports.constraintRefSame = constraintRefSame;
// similar to frontend/src/Models/Project/ColumnType.elm
const attributeTypeParse = (type) => {
    let res;
    if (type.endsWith('[]'))
        return { ...(0, exports.attributeTypeParse)(type.slice(0, -2)), array: true };
    if (res = /^array<(.*)>$/gi.exec(type)) {
        const [, subType] = res;
        return { ...(0, exports.attributeTypeParse)(subType), array: true };
    }
    if (res = /^(?:n)?(var)?(?:bit|string|(?:bp)?char(?:acter)?)(\s+varying)?(?:\((\d+)\))?(?:\s+character set ([^ ]+))?$/gi.exec(type)) {
        const [, var1, var2, size, encoding] = res;
        return (0, utils_1.removeUndefined)({ full: type, kind: 'string', size: size ? parseInt(size) : undefined, variable: var1 || var2 ? true : undefined, encoding });
    }
    if (/^(tiny|medium|long|ci)?text$/gi.exec(type))
        return { full: type, kind: 'string', variable: true };
    if (res = /^(tiny|small|big)?(?:int(?:eger)?|serial)(2|4|8|64)?(?:\((\d+)\))?(?:\s+unsigned)?$/gi.exec(type)) {
        const [, textSize, size] = res;
        return (0, utils_1.removeUndefined)({ full: type, kind: 'int', size: size === '64' ? 8 : size ? parseInt(size) : textSize ? parseSize(textSize) : 4 });
    }
    if (res = /^(?:real|float)([248])?$/gi.exec(type)) {
        const [, size] = res;
        return { full: type, kind: 'float', size: size ? parseInt(size) : 4 };
    }
    if (/^double precision$/gi.exec(type))
        return { full: type, kind: 'float', size: 8 };
    if (/^(?:decimal|numeric|number)(\s*\(\s*\d+\s*,\s*\d+\s*\))?$/gi.exec(type))
        return { full: type, kind: 'float' };
    if (/^bool(?:ean)?$/gi.exec(type))
        return { full: type, kind: 'bool' };
    if (/^date$/gi.exec(type))
        return { full: type, kind: 'date', size: 4 };
    if (res = /^time(tz)?(\s+with time zone)?(\s+without time zone)?$/gi.exec(type)) {
        const [, tz, hasTz] = res;
        return { full: type, kind: 'time', size: tz || hasTz ? 12 : 8 };
    }
    if (/^timestamp(tz)?(?:\((\d+)\))?(\s+with time zone)?(\s+without time zone)?$/gi.exec(type))
        return { full: type, kind: 'instant', size: 8 };
    if (/^datetime$/gi.exec(type))
        return { full: type, kind: 'instant' };
    if (/^interval(?:\((\d+)\))?(\s+'[^']+')?$/gi.exec(type))
        return { full: type, kind: 'period', size: 16 };
    if (/^bytea$/gi.exec(type))
        return { full: type, kind: 'binary' };
    if (/^(tiny|medium|long)?blob$/gi.exec(type))
        return { full: type, kind: 'binary', variable: true };
    if (/^uuid$/gi.exec(type))
        return { full: type, kind: 'uuid' };
    if (/^jsonb?$/gi.exec(type))
        return { full: type, kind: 'json' };
    if (/^xml$/gi.exec(type))
        return { full: type, kind: 'xml' };
    return { full: type, kind: 'unknown' };
};
exports.attributeTypeParse = attributeTypeParse;
const parseSize = (textSize) => textSize === 'tiny' ? 1 : textSize === 'small' ? 2 : textSize === 'big' ? 8 : undefined;
const typeRefToId = (ref) => {
    const ns = (0, exports.namespaceToId)(ref);
    return ns ? `${ns}.${ref.type}` : addQuotes(ref.type);
};
exports.typeRefToId = typeRefToId;
const typeRefFromId = (id) => {
    const [type, schema, catalog, ...database] = id.split('.').reverse().map(removeQuotes);
    const namespace = (0, utils_1.filterValues)({ database: database.reverse().join('.'), catalog, schema }, v => !!v);
    return { ...namespace, type };
};
exports.typeRefFromId = typeRefFromId;
const typeRefSame = (a, b) => (a.type === b.type || a.type === '*' || b.type === '*') &&
    (a.schema === b.schema || a.schema === '*' || b.schema === '*') &&
    (a.catalog === b.catalog || a.catalog === '*' || b.catalog === '*') &&
    (a.database === b.database || a.database === '*' || b.database === '*');
exports.typeRefSame = typeRefSame;
const typeToNamespace = (t) => (0, exports.namespace)(t);
exports.typeToNamespace = typeToNamespace;
const typeToRef = (t) => (0, utils_1.removeUndefined)({ ...(0, exports.namespace)(t), type: t.name });
exports.typeToRef = typeToRef;
const typeToId = (t) => (0, exports.typeRefToId)((0, exports.typeToRef)(t));
exports.typeToId = typeToId;
const relationLinkToEntityRef = (l) => (0, utils_1.removeUndefined)({ ...(0, exports.namespace)(l), entity: l.entity });
exports.relationLinkToEntityRef = relationLinkToEntityRef;
const relationLinkToAttributeRef = (l) => ({ ...(0, exports.relationLinkToEntityRef)(l), attributes: l.attrs });
exports.relationLinkToAttributeRef = relationLinkToAttributeRef;
const relationToRef = (r) => ({ src: (0, exports.relationLinkToAttributeRef)(r.src), ref: (0, exports.relationLinkToAttributeRef)(r.ref) });
exports.relationToRef = relationToRef;
const relationToId = (r) => (0, exports.relationRefToId)((0, exports.relationToRef)(r));
exports.relationToId = relationToId;
const relationRefToId = (ref) => `${(0, exports.attributesRefToId)(ref.src)}->${(0, exports.attributesRefToId)(ref.ref)}`;
exports.relationRefToId = relationRefToId;
const relationRefFromId = (id) => {
    const [, src, ref] = id.match(/^([^(]*\([^)]*\))->([^(]*\([^)]*\))$/) || [];
    return { src: (0, exports.attributesRefFromId)(src), ref: (0, exports.attributesRefFromId)(ref) };
};
exports.relationRefFromId = relationRefFromId;
const relationRefSame = (a, b) => (0, exports.attributesRefSame)(a.src, b.src) && (0, exports.attributesRefSame)(a.ref, b.ref);
exports.relationRefSame = relationRefSame;
function addQuotes(value) {
    if (value.match(/^\w*$/)) {
        return value;
    }
    else {
        return `"${value}"`;
    }
}
function removeQuotes(value) {
    if (value.startsWith('"') && value.endsWith('"')) {
        return value.slice(1, -1);
    }
    else if (value.startsWith("'") && value.endsWith("'")) {
        return value.slice(1, -1);
    }
    else if (value.startsWith("`") && value.endsWith("`")) {
        return value.slice(1, -1);
    }
    else if (value.startsWith("[") && value.endsWith("]")) { // SQL Server way ^^
        return value.slice(1, -1);
    }
    else {
        return value;
    }
}
function getAttribute(attrs, path) {
    const [head, ...tail] = path;
    const attr = (attrs || []).find(a => a.name == head);
    if (attr && tail.length === 0) {
        return attr;
    }
    else if (attr && tail.length > 0) {
        return getAttribute(attr.attrs || [], tail);
    }
    else {
        return undefined;
    }
}
function getPeerAttributes(attrs, path) {
    const [head, ...tail] = path;
    if (attrs && tail.length > 0) {
        const attr = (attrs || []).find(a => a.name == head);
        return getPeerAttributes(attr?.attrs, tail);
    }
    else {
        return attrs || [];
    }
}
function flattenAttributes(attrs) {
    return (attrs || []).flatMap(a => flattenAttribute(a));
}
function flattenAttribute(attr, p = []) {
    const path = [...p, attr.name];
    return [{ ...attr, path }, ...(attr.attrs || []).flatMap(a => flattenAttribute(a, path))];
}
function attributeValueToString(value) {
    if (typeof value === 'string')
        return value;
    if (typeof value === 'number')
        return value.toString();
    if (typeof value === 'boolean')
        return value.toString();
    if (value instanceof Date)
        return value.toISOString();
    if (value === null)
        return 'null';
    return JSON.stringify(value);
}
const indexEntities = (entities) => (0, utils_1.indexBy)(entities, exports.entityToId);
exports.indexEntities = indexEntities;
const indexRelations = (relations) => (0, utils_1.mapValues)((0, utils_1.groupBy)(relations, r => (0, exports.entityRefToId)(r.src)), rels => (0, utils_1.groupBy)(rels, r => (0, exports.entityRefToId)(r.ref)));
exports.indexRelations = indexRelations;
const indexTypes = (types) => (0, utils_1.indexBy)(types, exports.typeToId);
exports.indexTypes = indexTypes;
function parseJsonDatabase(content) {
    let json = undefined;
    try {
        json = JSON.parse(content);
    }
    catch (e) {
        return parserResult_1.ParserResult.failure([{ message: (0, utils_1.errorToString)(e), kind: 'MalformedJson', level: 'error', offset: { start: 0, end: 0 }, position: { start: { line: 0, column: 0 }, end: { line: 0, column: 0 } } }]);
    }
    return (0, zod_1.zodParse)(database_1.Database)(json).fold(db => parserResult_1.ParserResult.success(db), err => parserResult_1.ParserResult.failure([{ message: err, kind: 'InvalidJson', level: 'error', offset: { start: 0, end: 0 }, position: { start: { line: 0, column: 0 }, end: { line: 0, column: 0 } } }]));
}
function generateJsonDatabase(database) {
    return (0, utils_1.stringify)(database, (path, value) => {
        const last = path[path.length - 1];
        // if (last === 'entities' || last === 'relations' || last === 'types') return 0
        if (path.includes('attrs') && last !== 'attrs')
            return 0;
        if (path.includes('pk'))
            return 0;
        if (path.includes('indexes') && path.length > 3)
            return 0;
        if (path.includes('checks') && path.length > 3)
            return 0;
        if (path.includes('relations') && path.length > 2)
            return 0;
        if (path.includes('types') && path.length > 1)
            return 0;
        if (path.includes('stats'))
            return 0;
        if (path.includes('extra') && path.length > 1)
            return 0;
        return 2;
    }) + '\n';
}
// the first database has priority on the second one when it makes sense
function mergeDatabase(a, b) {
    return (0, utils_1.removeEmpty)({
        entities: (0, utils_1.mergeBy)(a.entities || [], b.entities || [], exports.entityToId, mergeEntity),
        relations: (0, utils_1.mergeBy)(a.relations || [], b.relations || [], exports.relationToId, mergeRelation),
        types: (0, utils_1.mergeBy)(a.types || [], b.types || [], exports.typeToId, mergeType),
        doc: a.doc || b.doc,
        stats: mergeStats(a.stats, b.stats),
        extra: mergeDatabaseExtra(a.extra, b.extra),
    });
}
function mergeDatabaseExtra(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    const extra = (0, utils_1.filterKeys)(Object.assign({}, b || {}, a || {}), k => !database_1.databaseExtraKeys.includes(k.toString())); // a should overrides b
    return (0, utils_1.removeUndefined)({
        source: mergeOneOrSame(a.source, b.source),
        createdAt: mergeOneOrSame(a.createdAt, b.createdAt),
        creationTimeMs: mergeOneOrSame(a.creationTimeMs, b.creationTimeMs),
        comments: a.comments && b.comments ? a.comments.concat(b.comments) : a.comments || b.comments, // keep all comments
        namespaces: a.namespaces && b.namespaces ? undefined : a.namespaces || b.namespaces, // remove if defined in both
        ...extra
    });
}
function mergeEntity(a, b) {
    return (0, utils_1.removeUndefined)({
        database: a.database, // keep the 'a' reference (database, catalog, schema, name), should be the same as b
        catalog: a.catalog,
        schema: a.schema,
        name: a.name,
        kind: a.kind, // don't change kind, undefined means table
        def: a.def || b.def,
        attrs: a.attrs && b.attrs ? (0, utils_1.mergeBy)(a.attrs, b.attrs, attr => attr.name, mergeAttribute) : a.attrs || b.attrs,
        pk: a.pk && b.pk ? mergePrimaryKey(a.pk, b.pk) : a.pk || b.pk,
        indexes: a.indexes && b.indexes ? (0, utils_1.mergeBy)(a.indexes, b.indexes, i => i.attrs.map(exports.attributePathToId).join(','), mergeIndex) : a.indexes || b.indexes,
        checks: a.checks && b.checks ? (0, utils_1.mergeBy)(a.checks, b.checks, c => c.predicate + ':' + c.attrs.map(exports.attributePathToId).join(','), mergeCheck) : a.checks || b.checks,
        doc: a.doc || b.doc,
        stats: mergeStats(a.stats, b.stats),
        extra: mergeEntityExtra(a.extra, b.extra),
    });
}
function mergeEntityExtra(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    const extra = (0, utils_1.filterKeys)(Object.assign({}, b || {}, a || {}), k => !database_1.entityExtraKeys.includes(k.toString())); // a should overrides b
    return (0, utils_1.removeUndefined)({
        line: a.line || b.line,
        statement: a.statement || b.statement,
        alias: a.alias || b.alias,
        color: a.color || b.color,
        tags: a.tags && b.tags ? (0, utils_1.distinct)(a.tags.concat(b.tags)) : a.tags || b.tags,
        comment: a.comment || b.comment,
        ...extra
    });
}
function mergeAttribute(a, b) {
    return (0, utils_1.removeUndefined)({
        name: a.name, // keep the 'a' reference (name), should be the same as b
        type: a.type === '' || a.type === legacyDatabase_1.legacyColumnTypeUnknown ? b.type : a.type,
        null: a.null || b.null,
        gen: a.gen, // don't change unique, undefined means 'false'
        default: a.default || b.default,
        attrs: a.attrs && b.attrs ? (0, utils_1.mergeBy)(a.attrs, b.attrs, attr => attr.name, mergeAttribute) : a.attrs || b.attrs,
        doc: a.doc || b.doc,
        stats: mergeStats(a.stats, b.stats),
        extra: mergeAttributeExtra(a.extra, b.extra),
    });
}
function mergeAttributeExtra(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    const extra = (0, utils_1.filterKeys)(Object.assign({}, b || {}, a || {}), k => !database_1.attributeExtraKeys.includes(k.toString())); // a should overrides b
    return (0, utils_1.removeUndefined)({
        line: a.line || b.line,
        statement: a.statement || b.statement,
        autoIncrement: a.autoIncrement === undefined ? b.autoIncrement : a.autoIncrement,
        hidden: a.hidden === undefined ? b.hidden : a.hidden,
        tags: a.tags && b.tags ? (0, utils_1.distinct)(a.tags.concat(b.tags)) : a.tags || b.tags,
        comment: a.comment || b.comment,
        ...extra
    });
}
function mergePrimaryKey(a, b) {
    return (0, utils_1.removeUndefined)({
        name: a.name || b.name,
        attrs: a.attrs, // don't change primary key attrs
        doc: a.doc || b.doc,
        stats: mergeStats(a.stats, b.stats),
        extra: mergeIndexExtra(a.extra, b.extra),
    });
}
function mergeIndex(a, b) {
    return (0, utils_1.removeUndefined)({
        name: a.name || b.name,
        attrs: a.attrs, // keep the 'a' reference (attrs & predicate), should be the same as b
        unique: a.unique, // don't change unique, undefined means 'false'
        partial: a.partial, // don't change partial, undefined means 'false'
        definition: a.definition || b.definition,
        doc: a.doc || b.doc,
        stats: mergeStats(a.stats, b.stats),
        extra: mergeIndexExtra(a.extra, b.extra),
    });
}
function mergeCheck(a, b) {
    return (0, utils_1.removeUndefined)({
        name: a.name || b.name,
        attrs: a.attrs, // keep the 'a' reference (attrs & predicate), should be the same as b
        predicate: a.predicate,
        doc: a.doc || b.doc,
        stats: mergeStats(a.stats, b.stats),
        extra: mergeIndexExtra(a.extra, b.extra),
    });
}
function mergeIndexExtra(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    const extra = (0, utils_1.filterKeys)(Object.assign({}, b || {}, a || {}), k => !database_1.indexExtraKeys.includes(k.toString())); // a should overrides b
    return (0, utils_1.removeUndefined)({
        line: a.line || b.line,
        statement: a.statement || b.statement,
        ...extra
    });
}
function mergeRelation(a, b) {
    return (0, utils_1.removeUndefined)({
        name: a.name || b.name,
        origin: a.origin, // don't change origin, undefined means 'fk'
        src: a.src, // keep the 'a' reference (src & ref), should be the same as b
        ref: a.ref,
        polymorphic: a.polymorphic || b.polymorphic,
        doc: a.doc || b.doc,
        extra: mergeRelationExtra(a.extra, b.extra),
    });
}
function mergeRelationExtra(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    const extra = (0, utils_1.filterKeys)(Object.assign({}, b || {}, a || {}), k => !database_1.relationExtraKeys.includes(k.toString())); // a should overrides b
    return (0, utils_1.removeUndefined)({
        line: a.line || b.line,
        statement: a.statement || b.statement,
        inline: mergeOneOrSame(a.inline, b.inline),
        natural: a.natural || b.natural,
        onUpdate: a.onUpdate || b.onUpdate,
        onDelete: a.onDelete || b.onDelete,
        srcAlias: a.srcAlias || b.srcAlias,
        refAlias: a.refAlias || b.refAlias,
        tags: a.tags && b.tags ? (0, utils_1.distinct)(a.tags.concat(b.tags)) : a.tags || b.tags,
        comment: a.comment || b.comment,
        ...extra
    });
}
function mergeType(a, b) {
    return (0, utils_1.removeUndefined)({
        database: a.database, // keep the 'a' reference (database, catalog, schema, name), should be the same as b
        catalog: a.catalog,
        schema: a.schema,
        name: a.name,
        alias: a.alias || b.alias,
        values: a.values && b.values ? (0, utils_1.distinct)(a.values.concat(b.values)) : a.values || b.values,
        attrs: a.attrs && b.attrs ? (0, utils_1.mergeBy)(a.attrs, b.attrs, attr => attr.name, mergeAttribute) : a.attrs || b.attrs,
        definition: a.definition || b.definition,
        doc: a.doc || b.doc,
        extra: mergeTypeExtra(a.extra, b.extra),
    });
}
function mergeTypeExtra(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    const extra = (0, utils_1.filterKeys)(Object.assign({}, b || {}, a || {}), k => !database_1.typeExtraKeys.includes(k.toString())); // a should overrides b
    return (0, utils_1.removeUndefined)({
        line: a.line || b.line,
        statement: a.statement || b.statement,
        inline: mergeOneOrSame(a.inline, b.inline),
        tags: a.tags && b.tags ? (0, utils_1.distinct)(a.tags.concat(b.tags)) : a.tags || b.tags,
        comment: a.comment || b.comment,
        ...extra
    });
}
function mergeStats(a, b) {
    // keep stats only when just one db has them, otherwise discard them to avoid false stats on db but allow extending a db with stats
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    return undefined;
}
function mergeOneOrSame(a, b) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    if (a === b)
        return a;
    return undefined; // remove if defined differently in both
}
//# sourceMappingURL=databaseUtils.js.map